import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CredentialModalComponent } from "@/shared/components/credential-modal/credential-modal.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ButtonModule } from "@airnauts/ng-components/button";
import { InputModule } from "@airnauts/ng-components/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";


@NgModule({
  declarations: [
    CredentialModalComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    InputModule,
    MatFormFieldModule,
    MatInputModule,
  ],
  exports: [
    CredentialModalComponent,
  ],
})
export class CredentialModalModule { }
